interface INewsletterInfo{
  id?: number;
  object?: string;
  message?: string;
  createdAt?: Date;
}

export class NewsletterInfo implements INewsletterInfo{
  constructor(public id?: number, public object?: string, public message?: string, public createdAt?:Date) {
    this.id = this.id;
    this.object = this.object;
    this.message = this.message;
    this.createdAt = this.createdAt;
  }
}
